/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */
import {useTranslation} from "react-i18next";
import React, {useLayoutEffect, useRef} from "react";
import {CustomLevelCardStyle} from "../../../../../components/Styles";
import CustomGenericTittleIconDataChip from "../../../../../components/CustomGenericTittleIconDataChip";
import {
    calculateHeight,
    downloadActionFile,
    EMPTY_VALUES,
    getDateFormat,
    getTimeFormat,
    isSmWidth
} from "../../../../../Apis/functions";
import CustomChip from "../../../../../components/CustomChip";
import {statusBorderColor, statusColor, statusFontColor} from "../../../../../enums/statusColorEnum";
import {
    EmailSubsectionChip,
    IconScheduleTable,
    MobileIcon,
    IconDocumentLines,
    TimePickerChip, IconDocumentPencilEdit
} from "../../../../../components/buttons/IconButtons";
import CustomTooltip from "../../../../../components/CustomTooltip";
import CustomFileCard from "../../../../../components/CustomFileCard";
import {status} from "../../../../../enums/statusEnum";
import {getMaterialRequestStatusId} from "../../Model/Model";

const MaterialRequestDetailsSectionInfo = ({
                                     item,
                                     evidence,
                                     contentCardRef
                                 }) => {

    const {t} = useTranslation();
    const statusId = getMaterialRequestStatusId(item);
    const styles = CustomLevelCardStyle(item?.dispatchStatusId, false);
    const elementRef = useRef();

    useLayoutEffect(() => {
        if(isSmWidth()) return;
        calculateHeight({elementRef: elementRef, bottom:100})
    }, [item]);

    return (
        <>
            <div style={styles.container}>
                <div className='d-flex justify-content-between align-items-center h-72px' style={styles.levelCard}>
                    <div className={"mr-3"}>
                        <CustomGenericTittleIconDataChip
                            title={'request_details'}
                            Icon={IconDocumentPencilEdit}
                            border={false}
                            titleBoxClass={'d-flex'}
                        />
                    </div>

                    <CustomChip
                        variant={'large'}
                        background={statusColor[statusId]}
                        fontColor={statusFontColor[statusId]}
                        borderColor={statusBorderColor[statusId]}
                        legend={
                            <CustomTooltip
                                text={t(status[statusId])}
                                classes={`fs-12px text-ellipsis-1-row`}
                                showIfTruncated={true}
                            />
                        }
                        className={"flex-grow-0 minw-0"}
                    />
                </div>

                <div className='row align-items-start p-3 overflow-y-auto' ref={contentCardRef}>
                    <div className='col-2 p-0'>
                        <div className='background-secondary-100 p-8px border-radius-8px d-flex justify-content-center'>
                            <IconDocumentLines/>
                        </div>
                    </div>
                    <div className='col-10'>
                        <div className='row px-0 ml-0 pl-0'>
                            <div className='col-12 px-0'>
                                <p className='font-color-general-950 fs-14px ibl-font-w-600 px-0 text-uppercase'>
                                    {item?.code}
                                </p>
                                <p className='font-color-general-950 fs-14px ibl-font-w-400 px-0 mb-1'>
                                    {item?.requestedBy}
                                </p>
                            </div>
                            <div className={'row mt-2 ml-0 pl-0 ml-0'}>
                                <div className={'d-flex justify-content-between p-0 gap-3 '}>
                                    <div className={'d-flex flex-grow-1 minw-0 align-items-center'}>
                                        <div className={'mr-2 d-flex align-items-center'}>
                                            <EmailSubsectionChip/>
                                        </div>
                                        <div className={'flex-grow-1 minw-0'}>
                                            <CustomTooltip
                                                text={item?.requestedByEmail}
                                                classes={`fs-14px font-color-general-950 text-ellipsis-1-row align-items-center`}
                                                showIfTruncated={true}
                                            />
                                        </div>
                                    </div>
                                    <div className={'d-flex flex-grow-1 minw-0'}>
                                        <div className={'mr-2 d-flex align-items-center'}>
                                            <MobileIcon className='icon-color-shades-800 flex-shrink-0'/>
                                        </div>
                                        <div className={'flex-grow-1 minw-0'}>
                                            <CustomTooltip
                                                text={item?.requestedByPhoneNumber || EMPTY_VALUES.DEFAULT}
                                                classes={`fs-14px font-color-general-950 text-ellipsis-1-row`}
                                                showIfTruncated={true}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='border-bottom-shades-300 my-3'/>

                            <p className='font-color-general-950 fs-14px ibl-font-w-600 px-0'>
                                {t('vehicle_information')}
                            </p>
                            <p className='font-color-general-950 fs-14px px-0'>
                                {item?.vehicleInformation || EMPTY_VALUES.DEFAULT}
                            </p>

                            <div className='border-bottom-shades-300 my-3'/>

                            <p className='font-color-general-950 fs-14px ibl-font-w-600 px-0'>{t('request_date')}</p>
                            <div className='col-sm-12 col-md-6 px-0'>
                                <div className='d-flex flex-grow-1 minw-0 justify-content-between p-0'>
                                    <div className={"mr-2 d-flex align-items-center"}>
                                        <IconScheduleTable/>
                                    </div>
                                    <div className={"flex-grow-1 minw-0"}>
                                        <CustomTooltip
                                            text={`${item?.createdAt ? getDateFormat(item?.createdAt, false) : EMPTY_VALUES.DEFAULT}`}
                                            classes={`fs-14px font-color-general-950 text-ellipsis-1-row`}
                                            showIfTruncated={true}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className='col-sm-12 col-md-6 px-0'>
                                <div className='d-flex flex-grow-1 minw-0 justify-content-between p-0'>
                                    <div className={"mr-2 d-flex align-items-center"}>
                                        <TimePickerChip/>
                                    </div>
                                    <div className={"flex-grow-1 minw-0"}>
                                        <CustomTooltip
                                            text={`${item?.createdAt ? getTimeFormat(item?.createdAt, false) : EMPTY_VALUES.DEFAULT}`}
                                            classes={`fs-14px font-color-general-950 text-ellipsis-1-row`}
                                            showIfTruncated={true}
                                        />
                                    </div>
                                </div>
                            </div>


                            <div className='border-bottom-shades-300 mt-3'/>
                            <p className='font-color-general-950 fs-14px ibl-font-w-600 px-0 my-3'>
                                {t('supporting_documentation')}
                            </p>

                            <div className='overflow-y-auto px-0' ref={elementRef}>
                                {evidence?.map((e) => {
                                    return (
                                        <div className={'mt-2'}>
                                            <CustomFileCard
                                                Icon={e.Icon}
                                                title={e.name}
                                                subtitle={
                                                    <p className={'justify-content-start d-flex ibl-font-w-400 fs-10px'}>
                                                        {e.size}
                                                    </p>
                                                }
                                                fileValue={e.filePath}
                                                buttonId={'btn_mrd_download_' + e.id}
                                                onClick={() => downloadActionFile(e.filePath)}
                                            />
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default MaterialRequestDetailsSectionInfo;
